export default {
  get name(): string {
    return 'ExpoNavigationBar';
  },
};
